/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'
import qs from 'qs'

const http ={
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url,params){
        const config = {
            method: 'GET',
            url:url
        }
		if(params) config.params = params
        return request(config)
    },
    post(url,params,type){
        const config = {
            method: 'POST',
            url:url
        }
        if(type){
            if(params) config.data = params
            config.headers =  {
                'Content-Type': 'multipart/form-data',
            }

        }else{
            if(params) config.data = qs.stringify(params)
        }

        return request(config)
	},
    put(url,params){
        const config = {
            method: 'PUT',
            url:url
        }
        if(params) config.params = JSON.stringify(params)
        return request(config)
    },
    delete(url,params){
        const config = {
            methods: 'DELETE',
            url:url
        }
        if(params) config.params = params
        return request(config)
    }
}
//导出
export default http
